import { Caption, Title, IconSticker } from '@yaradigitallabs/ahua-react';
export const SelectedSoftTagEmptyState = () => {
  return (
    <div className="flex h-full min-h-[200px] w-full flex-col items-center justify-center gap-6 rounded-md bg-white p-6 text-center">
      <IconSticker colorConcept="brand" icon="Info" size="xl" />
      <div className="flex w-full max-w-[220px] flex-col items-center justify-center text-center">
        <Title size="s" css={{ textAlign: 'center', width: '100%' }}>
          No soft tags selected yet
        </Title>
        <Caption css={{ marginTop: '8px', textAlign: 'center', width: '100%' }}>
          Search for soft tags and select up to 5 from the list on the left.
        </Caption>
      </div>
    </div>
  );
};
